<script>
  import { createEventDispatcher, onDestroy } from "svelte";

  const dispatch = createEventDispatcher();
  const close = () => dispatch("close");

  let modal;
  let styleText = '';
  export {styleText as style};

  const handle_keydown = e => {
    if (e.key === "Escape") {
      close();
      return;
    }

    if (e.key === "Tab") {
      // trap focus
      const nodes = modal.querySelectorAll("*");
      const tabbable = Array.from(nodes).filter(n => n.tabIndex >= 0);

      let index = tabbable.indexOf(document.activeElement);
      if (index === -1 && e.shiftKey) index = 0;

      index += tabbable.length + (e.shiftKey ? -1 : 1);
      index %= tabbable.length;

      tabbable[index].focus();
      e.preventDefault();
    }
  };

  const previously_focused =
    typeof document !== "undefined" && document.activeElement;

  if (previously_focused) {
    onDestroy(() => {
      previously_focused.focus();
    });
  }
</script>

<style>
  .modal {
    width: calc(100vw - 4em);
    /*max-width: 32em;*/
    max-height: calc(100vh - 4em);
    transform: translate(-50%, -50%);
  }
</style>

<svelte:window on:keydown={handle_keydown} />

<div class="fixed top-0 left-0 w-full h-full bg-cool-gray-300 z-30" style="background: rgba(0, 0, 0, .54);" on:click={close} />

<div
  class="modal bg-white shadow rounded-lg fixed left-1/2 top-1/2 overflow-auto z-50"
  role="dialog"
  aria-modal="true"
  bind:this={modal}
  style={styleText}>
  <div class="relative">
         <!-- <button
          class="p-1 border-2 border-transparent text-gray-600 rounded-full
          hover:text-gray-500 focus:outline-none focus:text-gray-800
          focus:bg-gray-100 transition duration-150 ease-in-out absolute top-1 right-1"
          on:click={close}>
          <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414
              1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293
              4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd" />
          </svg>
        </button> -->
    <slot />
  </div>
</div>
